interface Action {
    payload: any,
    type: string
}

const CountiesReducer = (state = [], action: Action) => {
    switch (action.type) {
        case 'GET_COUNTIES':
            return action.payload;
        case 'RESET_COUNTIES':
            return [];
        default:
            return state;
    }
};

export default CountiesReducer;
